import React, { useState } from 'react';
import Brands from './Brands';
import Categories from './Categories';
import Sale from './Sale';
import style from './Menu.module.scss?module';
import { useUser } from '../../../Context/UserContext';
import { formatCurrencyEur } from '../../../Helper/formatter';
import Link from '../../../Abstracts/Link/Link';
import UserLoginPopUp from '../../../Abstracts/Modals/UserLoginPopUp/UserLoginPopUp';
import { useNavigate } from 'react-router-dom';

export enum MenuKey {
  brands = 'BRANDS',
  categories = 'CATEGORIES',
  sale = 'SALE',
}

interface IProps {
  closeSidebar: () => void;
}

const Menu: React.FC<IProps> = ({ closeSidebar }) => {
  const navigate = useNavigate();
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [activeKey, setActiveKey] = useState<string | null>(null);
  const { user } = useUser();

  const favouritesNavigation = () => {
    if (!user?.id) {
      setShowLoginPopup(true);
    } else {
      navigate('/products?view=grid&favs_only=1');
    }

    closeSidebar();
  };

  return (
    <div>
      {!activeKey && (
        <div className={style.navigation}>
          <div className="fw-bold">Navigation</div>
          {!user ? (
            <a
              href="/login"
              className="ps-3 py-1 text-black text-decoration-none"
            >
              <span>Login / Register</span>
            </a>
          ) : (
            <a
              href="/logout"
              className="ps-3 py-1 text-black text-decoration-none"
            >
              <span>Logout</span>
            </a>
          )}

          {user && (
            <>
              <UserLoginPopUp
                showLoginPopup={showLoginPopup}
                setShowLoginPopup={setShowLoginPopup}
                onLoginSuccess={() => {
                  setShowLoginPopup(false);
                }}
              />
              <button
                type="button"
                className="ps-3 py-1 text-black text-decoration-none bg-transparent border-0 w-100 text-start"
                onClick={favouritesNavigation}
              >
                <span>Favourites {`(${user?.favourites_count})`}</span>
              </button>
              {user?.vts_orders_visible && (
                <Link
                  to="/vts-order"
                  className="ps-3 py-1 text-black"
                  onClick={closeSidebar}
                >
                  <span>Virtual Trade Show Order</span>
                </Link>
              )}
              <Link
                to="/my-orders"
                className="ps-3 py-1 text-black"
                onClick={closeSidebar}
              >
                <span>My Orders</span>
              </Link>
              <Link
                to="/complaints"
                className="ps-3 py-1 text-black"
                onClick={closeSidebar}
              >
                Complaints
              </Link>
              <a
                href="/my-unpaid-invoices"
                className="ps-3 py-1 text-black text-decoration-none"
              >
                <span>{`Unpaid Invoices: ${formatCurrencyEur(
                  user?.erp_unpaid_sums ?? 0
                )}`}</span>
              </a>
            </>
          )}
          {user?.has_api_access && (
            <Link
              to={'/service-center/api'}
              className="ps-3 py-1 text-black"
              onClick={closeSidebar}
            >
              Api
            </Link>
          )}
          {user?.bonus && (
            <Link
              to={'/bonus'}
              className="ps-3 py-1 text-black"
              onClick={closeSidebar}
            >
              Bonus
            </Link>
          )}
        </div>
      )}

      <Brands
        active={activeKey}
        setActive={setActiveKey}
        closeSidebar={closeSidebar}
      />
      <Categories
        active={activeKey}
        setActive={setActiveKey}
        closeSidebar={closeSidebar}
      />

      <Sale
        active={activeKey}
        setActive={setActiveKey}
        closeSidebar={closeSidebar}
      />
    </div>
  );
};

export default Menu;
